import { ROUTES } from "@/constants";
import { NavBarList } from "@/constants/NavMenu";
import useAuth from "@/hooks/useAuth";
import { classNames } from "@/utils";
import { useState } from "react";
import { useLocation } from "react-router-dom";
import NotificationCard from "./NotificationsCard";

const Header = () => {
  const { pathname } = useLocation();
  const { userId } = useAuth();
  const [, setShowNotificationCard] = useState(false); // State for NotificationCard visibility

  if (!userId) {
    return null;
  }
  const isSetupProfilePage = pathname === ROUTES.PROFILE_SETUP;

  if (userId && isSetupProfilePage) {
    return null;
  }

  // const onClickBack = () => {
  //   window.history.back();
  // };

  // // eslint-disable-next-line
  // const handleNotificationClick = () => {
  //   setShowNotificationCard((prev) => !prev);
  // };

  return (
    <>
      <header
        className={classNames(`sticky-header-custom h-16 px-4 py-4 flex flex-row items-center justify-between gap-4 sticky top-0 z-[9] bg-monochrome-5`, {
          hidden: !userId,
        })}
      >
        <div className="mb-0">
          <h1 className="mb-0 text-xl font-bold">{NavBarList.find((item: any) => item.link === pathname || `${item.link}/` === pathname)?.title}</h1>
        </div>
      </header>
      <NotificationCard onClose={() => setShowNotificationCard(false)} />
    </>
  );
};

export default Header;
